const base_url = "https://traffiknsex.org/beta/";
// const base_url = "http://localhost/traffic/";
module.exports = {
  API_BASE_URL: `${base_url}api/`,
  API_UPLOADS_URL: `${base_url}uploads/`,
  API_ASSETS_IMAGES_URL: `${base_url}assets/images/`,
  API_CMS_BG_IMAGES_URL: `${base_url}uploads/images/`
};
